import { makeStyles } from "@material-ui/core/styles";
import useSlidesMenuWidth from "../components/SlidesMenu/useSlidesMenuWidth";
const useDashboardStyles = () => {
  const width = useSlidesMenuWidth();

  return makeStyles({
    page: {
      display: "flex",
      minHeight: "calc( 100vh - 148px )",
      maxHeight: "calc( 100vh - 148px )",
      background: "#EEEEF3",
      fontFamily: "'Dubai'",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "14px",
      // lineHeight: '20px',
      textAlign: "center",
      letterSpacing: "0.04375px",
      overflow: "hidden",
    },
    slidesMenu: {
      minHeight: "100%",
      maxHeight: "100%",
      borderInlineEnd: "1px solid rgba(0, 0, 0, 0.1)",
      overflow: "hidden",
      minWidth: `${width}px`,
    },
    slideView: {
      flexGrow: 1,
      minHeight: "100%",
      display: "flex",
      justifyContent: "center",
      paddingTop: "0px",
    },
  });
};
export default useDashboardStyles;
